import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  headingVariants,
  fadeInVariants,
  viewportSettings,
} from "../../../shared/utils/animations";
import styles from "./urban-luxury.module.scss";

const UrbanLuxury = (props: { url: string }) => {
  const navigate = useNavigate();

  return (
    <div className={`${styles["container"]}`}>
      <div className={`${styles["model-left-container"]}`}>
        <img
          draggable={false}
          src={props.url}
          alt="model"
          className={`${styles["model-image"]}`}
        />
      </div>
      <div
        className={`${styles["model-right-container"]} ${styles["meraki-welcome-container"]}`}
      >
        <motion.div
          initial="headingOffScreen"
          whileInView="headingOnScreen"
          viewport={viewportSettings}
          variants={headingVariants}
        >
          <h1>Hair Salon San Diego</h1>
        </motion.div>
        <motion.div
          initial="headingOffScreen"
          whileInView="headingOnScreen"
          viewport={viewportSettings}
          variants={headingVariants}
        >
          <h2>Urban Luxury</h2>
        </motion.div>
        <motion.div
          initial="fadeInOffScreen"
          whileInView="fadeInOnScreen"
          viewport={viewportSettings}
          variants={fadeInVariants}
        >
          <p>Welcome to the Meraki Lounge.</p>
        </motion.div>

        <motion.div
          initial="fadeInOffScreen"
          whileInView="fadeInOnScreen"
          viewport={viewportSettings}
          variants={fadeInVariants}
        >
          <button
            onClick={() => {
              navigate("/services");
            }}
          >
            View Services
          </button>
        </motion.div>
      </div>
    </div>
  );
};

export default UrbanLuxury;
